(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-draw.js');

'use strict';

const {
  isExaminedAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const {
  useMemo,
  useState,
  useEffect
} = React;
const {
  selectedResultAtom,
  playCorrectionTlAtom,
  correctionStepAtom,
  distributionArrayAtom,
  isLatestResultAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  useAtomValue,
  useSetAtom
} = jotai;
const {
  CONSTANTS: {
    CORRECTION_STEP
  },
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const {
  ResultDrawStartPrimary,
  ResultDrawStartSecondary,
  ResultDrawTopWin,
  MapCorrection
} = svs.lyckoplatsen.components.shared_result.react.components;
const {
  getDistributionArray
} = svs.lyckoplatsen.utils.page_result;
const ResultDraw = () => {
  const isExamined = useAtomValue(isExaminedAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const result = useAtomValue(selectedResultAtom);
  const play = useAtomValue(playCorrectionTlAtom);
  const isLatestResult = useAtomValue(isLatestResultAtom);
  const isPrimary = productMapping.isLyckoplatsenPrimary(result.productId);
  const [resultDrawStartVisible, setResultDrawStartVisible] = useState(true);
  const setDistributionArray = useSetAtom(distributionArrayAtom);
  const {
    distribution,
    distributionDrawItems,
    drawNumber
  } = result;
  const todaysWin = parseInt(distribution[0].amountSek, 10);
  const distributionArray = useMemo(() => {
    if (distributionDrawItems.length > 0) {
      return getDistributionArray({
        winPlan: distributionDrawItems,
        win: todaysWin,
        drawNumber
      });
    }
    return null;
  }, [distributionDrawItems, todaysWin, drawNumber]);
  setDistributionArray(distributionArray);
  useEffect(() => {
    if (isPrimary && correctionStep === CORRECTION_STEP.TOPWIN || !isPrimary && correctionStep === CORRECTION_STEP.PLACE) {
      setResultDrawStartVisible(true);
    }
  }, [correctionStep, isPrimary]);
  return React.createElement("div", {
    className: "lp-draw fc-white ".concat(play ? 'play' : 'paused', " ").concat(isPrimary ? 'primary' : 'secondary', " ").concat(isLatestResult ? 'latest' : '', " ").concat(isExamined ? '' : 'not-examined')
  }, isPrimary && correctionStep === CORRECTION_STEP.TOPWIN && React.createElement(ResultDrawStartPrimary, null), resultDrawStartVisible && !isPrimary && correctionStep === CORRECTION_STEP.PLACE && React.createElement(ResultDrawStartSecondary, {
    setResultDrawStartVisible: setResultDrawStartVisible
  }), React.createElement(ResultDrawTopWin, {
    className: "gsap-top-win gsap-hide"
  }), (correctionStep === CORRECTION_STEP.PLACE || correctionStep === CORRECTION_STEP.DISTANCE) && React.createElement(MapCorrection, null));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDraw
});

 })(window);